import { themeTextColorMap } from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'

import { iconSizeClassMap } from '../types/maps.ts'
import type { SvgIconProps } from './types/props.ts'

export const CircleIcon = (props: SvgIconProps) => {
  const { color, size, className } = props
  return (
    <svg
      {...props}
      width="6"
      height="6"
      viewBox="0 0 6 6"
      aria-hidden="true"
      role="img"
      className={cn(
        'fill-current',
        size !== 'inherit' && iconSizeClassMap[size],
        color && themeTextColorMap[color],
        className
      )}
    >
      <circle cx={3} cy={3} r={3} />
    </svg>
  )
}
